import { api } from "lwc";

import { createBaseContextProviderElement } from "common/context";
import { ContextAdapter } from "tds/contextAdapter";
import { Locale } from "@devforce/trailhead-client-locale";

export default class extends createBaseContextProviderElement(ContextAdapter) {
  @api assetsUrl: string | null = null;
  @api crossOriginAssets: boolean | null = null;
  @api locale: Locale | null = null;

  get localContext() {
    return {
      assetsUrl: this.assetsUrl,
      crossOriginAssets: this.crossOriginAssets,
      locale: this.locale,
    };
  }
}
